import _ from 'lodash';
import React from 'react';

import ReactTable from 'react-table';
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import IconCard from 'components/Cards/IconCard';
import { withApollo } from 'react-apollo';

import PhoneMsg from '@material-ui/icons/PermPhoneMsg';

import { callLogColumns } from '../constant';
import { getCallLogsQuery, gq_callLogs } from '../graph';

class CallLog extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            pages: 0,
            pageSize: 1,
            page: 1,
            loading: false,
            searchValue: "",
            pin: this.props.match.params.id,
            data: []
        }
    }
    fetchData(state, instance){

        this.setState({
            loading: true
        });
        if (state){
            var filterBy = JSON.stringify(state.filtered);
            var offset = state.page;
            var pageSize = state.pageSize;
            var sort = JSON.stringify(state.sorted);
        } else {
            var filterBy = JSON.stringify([]);
            var offset = 0;
            var pageSize = 10;
            var sort = JSON.stringify([]);
        }

        this.props.client.query({
            query: gq_callLogs,
            variables: {
                filterBy: filterBy,
                offset: offset,
                pageSize: pageSize,
                sort: sort,
                pin: this.state.pin
            },
            fetchPolicy: "network-only"
        }).then((data) => {
            let callData = data.data.callLogs.callLogs;
            let pages = data.data.callLogs.pages;

            this.setState({
                data: callData,
                loading: false,
                pages: pages
            });
        }).catch((error) => {
            console.log(error);
        })


        this.setState({ loading: true });
    }

    render(){
        const { pages, pageSize, page, searchValue, loading } = this.state;

        const callsView = (
            <ReactTable
                manual
                filterable
                pages={pages}
                data={this.state.data}
                onFetchData={this.fetchData.bind(this)}
                loading={loading}
                showPaginationTop
                showPaginationBottom={false}
                columns={callLogColumns}
                className="-striped -highlights"
                defaultPageSize={10}
            />
        );
        return(
            <GridContainer>
                <ItemGrid xs={12}>
                    <IconCard 
                        icon={PhoneMsg}
                        title="Call Logs"
                        content={
                            <ItemGrid xs={12}>
                                <ItemGrid xs={12} md={4}>
                                    <h4>{`PIN # ${this.state.pin}`}</h4>
                                </ItemGrid>
                                <ItemGrid xs={12} style={{marginTop: "15px"}}>
                                    {callsView}
                                </ItemGrid>
                            </ItemGrid>
                            }
                    />
                    </ItemGrid>
            </GridContainer>
        )
    }
}

export default (getCallLogsQuery)(withApollo(CallLog))



// WEBPACK FOOTER //
// ./src/views/pin/components/CallLog.js